import React from 'react';
import ReactDOM from 'react-dom/client';
// theme.tsx declares Inter as the app font but nothing ever loaded it, so the
// app silently rendered in Roboto/system. Self-hosted via @fontsource so there
// is no third-party request on the landing page's first-paint path.
import '@fontsource/inter/400.css';
import '@fontsource/inter/500.css';
import '@fontsource/inter/600.css';
import '@fontsource/inter/700.css';
// Mono, used only for the landing page's eyebrow labels.
import '@fontsource/jetbrains-mono/500.css';
import { BrowserRouter } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { ModulesProvider } from './context/ModulesContext';
import { ThemeProvider } from './theme';
import QueryProvider from './providers/QueryProvider';
import App from './App';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <ThemeProvider defaultTheme="palbon">
      {/* Outside the router so widget caches survive navigation — a dashboard
          that refetches every tile each time you come back from a detail page
          feels broken even when it is correct. */}
      <QueryProvider>
        <BrowserRouter>
          <AuthProvider>
            {/* Tenant entitlements, fetched once signed in — feeds the sidebar,
                the route guards and the marketplace. */}
            <ModulesProvider>
              <App />
            </ModulesProvider>
          </AuthProvider>
        </BrowserRouter>
      </QueryProvider>
    </ThemeProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();